import { call, put, CallEffect } from 'redux-saga/effects';
import { getApiData } from '../../../lib/api/getApiData';
import { BaseApiResponse } from '../../../lib/api/types/BaseApiResponse';
import { UserActions } from '../../actions/user';
export const getData = <T extends BaseApiResponse>(path: string): CallEffect<T> =>
    call(function* () {
        const response: T = yield call(() => getApiData(path));
        yield put(UserActions.isLoggedOn(response.isLoggedOn));
        return response;
    });
